import ShopArticlesListResourceModel from '../../generated/types/model/resource/ShopArticlesListResourceModel';

export default class ShopArticlesListResourceViewModel extends ShopArticlesListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
